import {
  GET_BANK_TRANSACTIONS_REQUEST,
  GET_BANK_TRANSACTIONS_SUCCESS,
  GET_BANK_TRANSACTIONS_FAILURE
} from 'Store/constants';

const initialState = {
  data: [],
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_BANK_TRANSACTIONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_BANK_TRANSACTIONS_SUCCESS:
      return {
        data: action.payload,
        isLoading: false,
        error: null
      };
    case GET_BANK_TRANSACTIONS_FAILURE:
      return { ...initialState, error: action.payload };
    default:
      return state;
  }
};
